const calculateAddonsMonthlyPrice = ({
  featureIds,
  additionalFeatures,
  skusPrice,
  skusIsOneTime,
  specialsPrice,
  specialsIsOneTime
}) => {
  const featuresSubscrTotal = featureIds.reduce((total, featureId) => {
    const {priceMonthly} = additionalFeatures.find((opt) => opt._id === featureId) || {};
    return total += priceMonthly;
  }, 0);

  const skusSubscrPrice = skusPrice && !skusIsOneTime ? skusPrice : 0;
  const specialsSubscrPrice = specialsPrice && !specialsIsOneTime ? specialsPrice : 0;
  const totalSubscriptionPrice = skusSubscrPrice + specialsSubscrPrice + featuresSubscrTotal;

  return totalSubscriptionPrice;
};

const calculateAddonsOneTypePrice = ({
  featureIds,
  additionalFeatures
}) => {
  const featuresOneTimeTotal = featureIds.reduce((total, featureId) => {
    const {priceOneTime = 0} = additionalFeatures.find((opt) => opt._id === featureId) || {};
    return total += priceOneTime;
  }, 0);

  return featuresOneTimeTotal;
};

const calculateMonthlySubscriptionByPeriod = ({baseMonthlyPrice = 0, addonsMonthlyPrice = 0, plan}) => {
  let totalPrice = baseMonthlyPrice + addonsMonthlyPrice;

  if (plan == 'annually') {
    // no additional costs here
  } else if (plan == 'semiAnnually') {
    totalPrice = totalPrice * 1.07;
  } else if (plan == 'monthly') {
    totalPrice = totalPrice * 1.15;
  }

  return totalPrice;
};

const calculatingTotalStorePrice = (prices, discounts, selectedDiscountsIds, couponCode) => {
  if (!prices?.length && !discounts?.length) {
    return {oneTime: 0, monthly: 0};
  }

  const totalPrices = prices.reduce((acc, option) => {
    if (option.isOneTime) {
      return {...acc, oneTime: acc.oneTime + option.price};
    }

    return {...acc, monthly: acc.monthly + option.price};
  }, {oneTime: 0, monthly: 0});

  const totalDiscounts = discounts.reduce((acc, option) => {
    if (option.isOneTime && selectedDiscountsIds.includes(option._id)) {
      return {...acc, oneTime: acc.oneTime + option.price};
    }

    if (!option.isOneTime && selectedDiscountsIds.includes(option._id)) {
      return {...acc, monthly: acc.monthly + option.price};
    }

    return acc;
  }, {oneTime: 0, monthly: 0});

  if (couponCode.discountOneTime || couponCode.discountMonthly) {
    totalDiscounts.oneTime += couponCode.discountOneTime || 0;
    totalDiscounts.monthly += couponCode.discountMonthly || 0;
  }

  const total = {
    oneTime: (totalPrices.oneTime - totalDiscounts.oneTime),
    monthly: (totalPrices.monthly - totalDiscounts.monthly)
  };

  return total;
};

export {
  calculateAddonsMonthlyPrice,
  calculateAddonsOneTypePrice,
  calculateMonthlySubscriptionByPeriod,
  calculatingTotalStorePrice
};
